<!-- INVALID ACCESS PERMISSION -->
<div *ngIf="!validToken" class="flex flex-column align-items-center justify-content-center mt-5">
	<div class="flex bg-red-200 p-1 border-round-xl w-full flex-column text-center">
		<p-tag [value]="('INVALID_PERMISSION' | translate)" severity="danger" styleClass="text-lg"></p-tag>
		<p-tag [value]="('INVALID_PERMISSION_REASON' | translate)" severity="danger" styleClass="text-lg"></p-tag>
	</div>
</div>

<!-- PINPAD -->
<div *ngIf="!validPin && validToken && !resetPin">
	<app-pin-pad (pinConfirmed)="onPinInserted($event)"></app-pin-pad>
</div>

<!-- ACCESS PAGE AFTER VALID PIN INSERT -->
<div *ngIf="validPin && !resetPin" class="flex flex-column align-items-center justify-content-center mt-5" >
	<!-- VALIDITY PERMISSION -->
	<div class="flex bg-green-200 p-1 border-round-xl w-full"
		[class]="!onExtendedMobile() ? 'flex-row justify-content-center' : 'flex-column text-center'">
		<p-tag [value]="('PIN_VALIDITY' | translate)" severity="success"
			[styleClass]="!onExtendedMobile() ? 'pr-0 text-lg' : 'text-lg'"></p-tag>
		<p-tag *ngIf="accessPermission !== undefined && accessPermission.End !== undefined"
			[value]="accessPermission.End  | localizedDate: 'medium'" severity="success"
			[styleClass]="!onExtendedMobile() ? ' text-lg' : 'text-lg'"></p-tag>
	</div>

	<!-- COMMANDS ACCESS -->
	<div *ngIf="accessPermission !== undefined" class="flex flex-column justify-content-center mt-5">
		<p-panel *ngFor="let automation of automationList | keyvalue" class="w-full"
			styleClass="mb-3">
			<ng-template pTemplate="header">
				<div class="flex align-items-center font-semibold gap-2">
					<!-- <div class="pi cm-devices"></div> -->
					{{ automation.key }}
				</div>
			</ng-template>
			<div class="grid m-0 flex align-items-center justify-content-center">
				<div *ngFor="let cmd of automation.value" [class]="this.onExtendedMobile() ? 'col-12 pb-0' : columnNumber">
					<button type="button" pButton pRipple id="buttonQuickEasyDeviceCommand-{{cmd.CommandDescription}}"
						[disabled]="!validPin" label="{{ cmd.CommandDescription }}" class="p-button-primary text-lg font-normal w-full"
						(click)="sendCommand(cmd)">
					</button>
				</div>
			</div>
		</p-panel>
	</div>
</div>

<!-- THS ACCESS -->
<div *ngIf="validPin && !resetPin && accessPermission !== undefined && permittedAccessThs !== undefined" class="flex align-items-center justify-content-center px-3">
	<p-panel *ngFor="let th of permittedAccessThs" class="grid mt-0">
		<ng-template pTemplate="header">
			<div class="flex align-items-center font-semibold gap-2">
				<div class="pi cm-termo"></div>
				{{ th.DeviceName }}
			</div>
		</ng-template>
		<div *ngIf="th.Online !== 1" class="col-12 p-0">
			<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl w-full flex-row">
				<div class="pi cm-alert text-yellow-700 pl-3"></div>
				<p-tag [value]="('OFFLINE_NOT_REACHABLE_THERMO' | translate)" severity="warning" styleClass="text-lg"></p-tag>
			</div>
		</div>
		<div *ngIf="th.Bb.Enable !== true || th.Qe.Enable !== true" class="col-12 p-0">
			<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl w-full flex-row">
				<div class="pi cm-alert text-yellow-700 pl-3"></div>
				<p-tag [value]="('TH_Q&E_DISABLE_ALERT' | translate)" severity="warning" styleClass="text-lg"></p-tag>
			</div>
		</div>
		<div *ngIf="th.Online === 1 && th.Bb.Enable === true && th.Qe.Enable === true" class="col-12 flex align-items-center justify-content-center pt-0">
			<!-- BnB MIN INFO, SLIDER, MAX INFO -->
			<div class="grid flex align-items-center mt-0">
				<!-- BnB MIN INFO MOBILE -->
				<div *ngIf="onExtendedMobile() && th.Bb?.thManualTempMin" class="col-6 flex justify-content-end py-0">
					<div class="flex flex-column w-16rem">
						<div class="flex align-items-center justify-content-center text-lg text-center">{{ 'MIN_VAR_AVAILABLE' | translate }}</div>
						<div class="flex align-items-center justify-content-center text-3xl">
							<div>{{th.Bb?.thManualTempMin}}°C</div>
						</div>
					</div>
				</div>
				<!-- BnB MAX INFO MOBILE -->
				<div *ngIf="onExtendedMobile() && th.Bb?.thManualTempMax" class="col-6 flex justify-content-start py-0">
					<div class="flex flex-column w-16rem">
						<div class="flex align-items-center justify-content-center text-lg text-center">{{ 'MAX_VAR_AVAILABLE' | translate }}</div>
						<div class="flex align-items-center justify-content-center text-3xl font-normal">
							<div>{{th.Bb?.thManualTempMax}}°C</div>
						</div>
					</div>
				</div>

				<!-- BnB MIN INFO DESKTOP / TABLET -->
				<div *ngIf="!onExtendedMobile() && th.Bb?.thManualTempMin" class="col-4 flex justify-content-end py-0">
					<div class="flex flex-column w-16rem">
						<div class="flex align-items-center justify-content-center text-lg">{{ 'MIN_VAR_AVAILABLE' | translate }}</div>
						<div class="flex align-items-center justify-content-center text-5xl">
							<div>{{th.Bb?.thManualTempMin}}°C</div>
						</div>
					</div>
				</div>
				<!-- SETPOINT BnB ROUND SLIDER -->
				<div *ngIf="th.Bb && th.Bb?.thManualTempMin && th.Bb?.thManualTempMax && th.Bb?.thManualTempStepsValue && th.Qe" [class]="onExtendedMobile() ? 'col-12' : 'col-4'">
					<div class="flex flex-column align-items-center justify-content-center">
						<p-knob id="set-temperature-q&e-access" [(ngModel)]="th.ManualTemp" valueTemplate="{{th.ManualTemp}}°C"
							size="200" [min]="th.Bb?.thManualTempMin" [max]="th.Bb?.thManualTempMax" [step]="th.Bb?.thManualTempStepsValue" class="cursor-pointer"
							textColor="var(--text-color, Black)" valueColor="#00B0ED" rangeColor="#CED1D4"
							(onChange)="sliderTempStop($event, th)">
						</p-knob>
						<div class="flex align-items-center justify-content-around w-18rem">
							<p-button icon="pi cm-minus" severity="primary" [rounded]="false" [text]="false"
								(click)="setSliderButtonValue(buttonsTempSet.DECREASE, th)"
								[disabled]="th.ManualTemp === th.Bb?.thManualTempMin"/>
							<p-button icon="pi cm-plus" severity="primary" [rounded]="false" [text]="false"
								(click)="setSliderButtonValue(buttonsTempSet.INCREASE, th)"
								[disabled]="th.ManualTemp === th.Bb?.thManualTempMax"/>
						</div>
					</div>
				</div>
				<!-- BnB MAX INFO DESKTOP / TABLET -->
				<div *ngIf="!onExtendedMobile() && th.Bb?.thManualTempMax" class="col-4 flex justify-content-start">
					<div class="flex flex-column w-16rem">
						<div class="flex align-items-center justify-content-center text-lg">{{ 'MAX_VAR_AVAILABLE' | translate }}</div>
						<div class="flex align-items-center justify-content-center text-5xl font-normal">
							<div>{{th.Bb?.thManualTempMax}}°C</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</p-panel>
</div>